import { Plus, Image as ImageIcon } from "lucide-react";

export function EmptyState({ onAddCategory }) {
  return (
    <div className="bg-white dark:bg-[#1E1E1E] border border-[#E5E7EB] dark:border-[#2A2A2A] rounded-xl p-12 text-center">
      <div className="w-16 h-16 bg-[#F5F3FF] dark:bg-[#2A2440] rounded-full flex items-center justify-center mx-auto mb-4">
        <ImageIcon size={32} className="text-[#62397f] dark:text-[#A78BFA]" />
      </div>
      <h3 className="text-xl font-bold text-[#111111] dark:text-white font-poppins mb-2">
        No categories yet
      </h3>
      <p className="text-sm text-[#666666] dark:text-[#A0A0A0] font-inter mb-6">
        Create your first category to organize products
      </p>
      <button
        onClick={onAddCategory}
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-[#62397f] to-[#7C3AED] text-white rounded-xl font-semibold text-sm font-inter transition-all duration-200 hover:shadow-lg hover:scale-105 active:scale-95"
      >
        <Plus size={18} />
        Add Category
      </button>
    </div>
  );
}
